import React, { useState } from "react";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-solid.css";
import { FontStyles } from "../../utils/font-styles.ts";
import { NumericInput } from "../../components/inputs/numeric-input.tsx";
import { InputIcon } from "../../components/input-icon.tsx";
import { useReportCalculatorInteraction } from "../hooks/use-report-calculator-interaction.ts";

export const PaymentCalculator: React.FC = () => {
  const [annualIncome, setAnnualIncome] = useState<number>();
  const [bonus, setBonus] = useState<number>();
  const [partnerIncome, setPartnerIncome] = useState<number>();
  const [partnerBonus, setPartnerBonus] = useState<number>();

  const reportFirstInteraction = useReportCalculatorInteraction("limit");

  const income1 = annualIncome ?? 0;
  const income2 = partnerIncome ?? 0;
  const bonus1 = bonus ?? 0;
  const bonus2 = partnerBonus ?? 0;
  const limit = (income1 + bonus1) * 4.5;
  const partner = (income2 + bonus2) * 4.5;
  const joint = (income1 + bonus1 + income2 + bonus2) * 4;
  const result = Math.round(Math.max(limit, Math.max(partner, joint)));

  return (
    <div className={"flex flex-col gap-4 pt-4 md:gap-6 md:pt-6"}>
      <div
        className={`${FontStyles["body-md"]} bg-cloud text-slate p-3.5 md:py-4 md:px-5.5 border-neutral-200 border-2 rounded-md`}
      >
        Use our payment calculator to discover the maximum amount you could borrow. These estimates are provided as
        illustrative figures for guidance only. Consider seeking advice from a professional mortgage advisor.
      </div>
      <div className={"flex flex-col gap-3.5 md:gap-6"}>
        <div className={"flex flex-col md:flex-row gap-3.5 md:gap-6.5"}>
          <NumericInput
            state={"default"}
            value={annualIncome}
            renderLeadingIcon={() => <InputIcon icon={`fa-solid fa-sharp fa-sterling-sign`} />}
            label={"Annual income"}
            labelSize="large"
            placeholder={"Enter annual income"}
            onValueChange={(value) => {
              reportFirstInteraction();
              setAnnualIncome(value);
            }}
          />
          <NumericInput
            state={"default"}
            value={bonus}
            renderLeadingIcon={() => <InputIcon icon={`fa-solid fa-sharp fa-sterling-sign`} />}
            label={"Annual bonus"}
            labelSize="large"
            placeholder={"Enter annual bonus"}
            onValueChange={(value) => {
              reportFirstInteraction();
              setBonus(value);
            }}
          />
        </div>
        <div className={"flex flex-col md:flex-row gap-3.5 md:gap-6.5"}>
          <NumericInput
            state={"default"}
            value={partnerIncome}
            renderLeadingIcon={() => <InputIcon icon={`fa-solid fa-sharp fa-sterling-sign`} />}
            label={"Partner's annual income"}
            labelSize="large"
            placeholder={"Enter partner's annual income"}
            onValueChange={(value) => {
              reportFirstInteraction();
              setPartnerIncome(value);
            }}
          />
          <NumericInput
            state={"default"}
            value={partnerBonus}
            renderLeadingIcon={() => <InputIcon icon={`fa-solid fa-sharp fa-sterling-sign`} />}
            label={"Partner's annual bonus"}
            labelSize="large"
            placeholder={"Enter partner's annual bonus"}
            onValueChange={(value) => {
              reportFirstInteraction();
              setPartnerBonus(value);
            }}
          />
        </div>
      </div>
      <div
        className={`${FontStyles["body-l"]} leading-snug md:leading-snug text-neutral-black p-3 bg-loch-50 
        border border-loch rounded-md text-center`}
      >
        You may borrow{" "}
        <span className={"font-semibold text-small-h5 md:text-h3"}>£{result.toLocaleString("en-GB")}</span>
      </div>
    </div>
  );
};
